export enum StudyAccessType {
  DEFAULT = 'default',
  PUBLIC = 'public',
  PRIVATE = 'private',
}

export enum PageStateEnum {
  LOADING,
  LOADED,
  NO_DATA,
}

export enum ActionEnum {
  EDIT,
  ADD,
}

export enum TrackItemType {
  SURVEY = 'survey',
  TEST = 'test',
  FITBIT = 'fitbit',
  HEALTHKIT = 'healthkit',
  ACTIVITY = 'activity',
  SLEEP = 'sleep',
}
